export const MagnifyingGlassIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g clipPath="url(#clip0_3084_7373)">
        <path d="M15.9583 15.958L19.1666 19.1663M18.2499 9.54134C18.2499 4.73186 14.3511 0.833008 9.54158 0.833008C4.73211 0.833008 0.833252 4.73186 0.833252 9.54134C0.833252 14.3508 4.73211 18.2497 9.54158 18.2497C14.3511 18.2497 18.2499 14.3508 18.2499 9.54134Z" />
      </g>
      <defs>
        <clipPath id="clip0_3084_7373">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
